// extracted by mini-css-extract-plugin
export default {"container":"SupplierData_container__4XLH3"};